import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgxEchartsModule } from 'ngx-echarts';

import { DailyChartComponent } from '@ruby/modules/order-fill/components/daily-chart/daily-chart.component';
import { OrderFillComponent } from '@ruby/modules/order-fill/components/order-fill/order-fill.component';
import { WeeklyChartComponent } from '@ruby/modules/order-fill/components/weekly-chart/weekly-chart.component';
import { OrderFillContainer } from '@ruby/modules/order-fill/containers/order-fill/order-fill.container';
import { OrderFillRoutingModule } from '@ruby/modules/order-fill/order-fill-routing.module';
import { effects, featureKey, reducer } from '@ruby/modules/order-fill/store';
import { OrderHistoryHeaderModule } from '@ruby/shared/inventory-management/order-history-header/order-history-header.module';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';

@NgModule({
  declarations: [
    OrderFillComponent,
    OrderFillContainer,
    WeeklyChartComponent,
    DailyChartComponent
  ],
  imports: [
    CommonModule,
    EffectsModule.forFeature(effects),
    OrderFillRoutingModule,
    StoreModule.forFeature(featureKey, reducer),
    MatCardModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    MatDividerModule,
    MatTabsModule,
    MatButtonModule,
    ReactiveFormsModule,
    OrderHistoryHeaderModule,
    NgxEchartsModule,
    PipesModule
  ],
  exports: [OrderFillContainer]
})
export class OrderFillModule {}
